import { render, staticRenderFns } from "./handitemxinxi.vue?vue&type=template&id=026c72fe&scoped=true"
import script from "./handitemxinxi.vue?vue&type=script&lang=js"
export * from "./handitemxinxi.vue?vue&type=script&lang=js"
import style0 from "./handitemxinxi.vue?vue&type=style&index=0&id=026c72fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026c72fe",
  null
  
)

export default component.exports